import heart_full_inactive_svg from "../../../images/heart_full_inactive_svg.svg";
import heart_full_active_svg from "../../../images/heart_full_active_svg.svg";

import heart_inactive_svg from "../../../images/heart_inactive_svg.svg";
import heart_active_svg from "../../../images/heart_active_svg.svg";
import {
  setMobileBackColor,
  setMobileCardBorderColor,
} from "../../../utility";
const SuggestionsFavoriteIcon = ({
  item,
  handleFavorite,
  favorites,
  suggested,
}) => {
  const onImageError = (e) => {
    e.target.src = heart_inactive_svg;
  };

  const onImageErrorSuggested = (e) => {
    e.target.src = heart_full_inactive_svg;
  };
  return (
    <span
      style={
        suggested
          ? {
              // backgroundColor: setMobileBackColor(),
              // borderColor: setMobileCardBorderColor(),
            }
          : {
              // backgroundColor: setMobileBackColor(),
              // borderColor: setMobileCardBorderColor(),
            }
      }
      className={`heart cursor ${
        !suggested
          ? localStorage.getItem("lang") === "ar" ||
            localStorage.getItem("lang") === "fa"
            ? "ms-2 suugestion_heart_style1 heart_style"
            : "me-2 suugestion_heart_style2 heart_style"
          : localStorage.getItem("lang") === "ar" ||
            localStorage.getItem("lang") === "fa"
          ? "ms-2"
          : "me-2"
      }`}
      onClick={(e) => {
        e.stopPropagation();
        handleFavorite(item);
      }}
    >
      {favorites.findIndex((fav) => fav.id === item.id) !== -1 ? (
        !suggested ? (
          <img
            src={heart_active_svg}
            className="heart"
            style={{ width: "24px", height: "24px" }}
            onError={onImageError}
          />
        ) : (
          <img
            src={heart_full_active_svg}
            className="heart"
            style={{ width: "24px", height: "24px" }}
            onError={onImageErrorSuggested}
          />
        )
      ) : !suggested ? (
        <img
          src={heart_inactive_svg}
          className="heart"
          style={{ width: "24px", height: "24px" }}
          onError={onImageError}
        />
      ) : (
        <img
          src={heart_full_inactive_svg}
          className="heart"
          style={{ width: "24px", height: "24px" }}
          onError={onImageErrorSuggested}
        />
      )}
    </span>
  );
};

export default SuggestionsFavoriteIcon;
